import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { QRCodeSVG } from 'qrcode.react';

import { formatDate, formatMoney, regexPhoneNumber, chequeNumber, checkPermission } from 'helpers/helpers'
import { getChequeNote, loadChequeNotes } from 'helpers/chequeNotes'
import { toNumber, getPrintProduct, drawingForCheque } from 'helpers/chequePrint'

import { useSelector } from 'react-redux';

function ChequeA4({ data = { products: [] }, printChequeRef, show = false }) {
	const { t } = useTranslation()

	const reduxAccount = useSelector(state => state.account)

	const [products, setProducts] = useState([]);
	const [accessories, setAccessories] = useState([]);
	const [tunikofons, setTunikofons] = useState([]);
	const [profs, setProfs] = useState([]);
	const [totalAmount, setTotalAmount] = useState({
		accessoryTotalQuantity: 0,
	});


	// A4 eslatma matnini fonda yangilab qo'yamiz (keyingi print uchun localStorage tayyor bo'lsin)
	useEffect(() => {
		loadChequeNotes()
	}, [])

	useEffect(() => {
		const productsData = data?.products || [];

		const type1 = [];
		const accessory = {
			children: [],
			preparedChildren: [],
			totalQuantity: 0,
			totalPrice: 0,
		};
		const tunikofon = {
			children: [],
			preparedChildren: [],
			totalQuantity: 0,
			totalPrice: 0,
		};
		const prof = {
			children: [],
			preparedChildren: [],
			totalQuantity: 0,
			totalPrice: 0,
		};

		const newTotalAmount = {
			productsTotalPrice: 0,
			productsTotalQuantity: 0,
			returnedSqM: 0,
			returnedMetr: 0,
			returnedCount: 0,
			returnedAmount: 0,
		};

		productsData.forEach(product => {
			const printProduct = getPrintProduct(product);
			if (printProduct.print_quantity <= 0) return;
			// Qaytarilgan miqdor/summa — pastda alohida "Қайтариш" satrida ko'rsatiladi
			newTotalAmount.returnedAmount += toNumber(printProduct.print_returned_amount);
			if (product.product_type === 5 && !product.is_prepared) {
				newTotalAmount.returnedSqM += toNumber(printProduct.print_returned_sq_m);
			} else if ((product.product_type === 3 || product.product_type === 4) && !product.is_prepared) {
				newTotalAmount.returnedMetr += toNumber(printProduct.print_returned_metr);
			} else {
				// Produkt (tur 1) va barcha tayyor mahsulotlar — DONA bilan qaytariladi
				newTotalAmount.returnedCount += toNumber(printProduct.print_returned_metr);
			}

			if (product.product_type === 1) {
				type1.push(printProduct);
				newTotalAmount.productsTotalQuantity += printProduct.print_quantity;
				newTotalAmount.productsTotalPrice += printProduct.print_total_price;
			} else if (product.product_type === 3) {
				if (product.is_prepared) {
					accessory.preparedChildren.push(printProduct);
					accessory.totalQuantity += printProduct.print_quantity;
				} else {
					accessory.children.push(printProduct);
					accessory.totalQuantity += printProduct.print_metr;
				}
				accessory.totalPrice += printProduct.print_total_price;
			} else if (product.product_type === 5) {
				if (product.is_prepared) {
					tunikofon.preparedChildren.push(printProduct);
					tunikofon.totalQuantity += printProduct.print_quantity;
				} else {
					tunikofon.children.push(printProduct);
					tunikofon.totalQuantity += printProduct.print_sq_m;
				}
				tunikofon.totalPrice += printProduct.print_total_price;
			} else if (product.product_type === 4) {
				if (product.is_prepared) {
					prof.preparedChildren.push(printProduct);
					prof.totalQuantity += printProduct.print_quantity;
				} else {
					prof.children.push(printProduct);
					prof.totalQuantity += printProduct.print_metr;
				}
				prof.totalPrice += printProduct.print_total_price;
			}
		});

		setProducts(type1);
		setProfs(prof);
		setAccessories(accessory);
		setTunikofons(tunikofon);
		setTotalAmount(newTotalAmount);
	}, [data.products]);

	/* NOM OSTIDAGI KICHIK MA'LUMOT — eni va yoyma (2026-08-13).
	   Chizmani o'z ustuniga chiqarganda nom katagi ostida joy bo'shadi;
	   u yerga mijoz uchun foydali o'lchamlarni qo'yamiz — ilgari mijoz
	   chekida bu ma'lumot UMUMAN yo'q edi va u qanday o'lchamdagi tovar
	   olayotganini bilmasdi.
	   `draw_json` satr ham, obyekt ham bo'lishi mumkin (drayverga qarab). */
	const drawSub = (item) => {
		const w = toNumber(item.draw_width) > 0 ? item.draw_width : item.width
		let dj = item.draw_json
		if (typeof dj === 'string') { try { dj = JSON.parse(dj) } catch (e) { dj = null } }
		const blank = toNumber(dj && dj.blank)
		const parts = []
		if (toNumber(w) > 0) parts.push(`${t('width')} ${formatMoney(w, 4)} m`)
		if (blank > 0) parts.push(`${t('blank').toLowerCase()} ${formatMoney(blank, 0)} mm`)
		if (!parts.length) return null
		return <div className="dw-sub">{parts.join(' · ')}</div>
	}

	/* CHIZMA USTUNI KO'RINSINMI (2026-08-13) — Kassadagi `showDrawCol` bilan
	   bir xil qoida. Chizma moduli faqat Full tarifda; qolgan 11 tenantда
	   ustun 100% bo'sh turardi va A5 jadval enining ~1/5 qismini yeb,
	   nom/narx/summani siqib qo'yardi.
	   ⚠️ Tarif TUSHIRILGAN tenantда eski chizma yo'qolmasin — shart ikkitadan:
	      ruxsat BOR yoki qatorlarda chizma BOR. */
	const showDraw = checkPermission('sec.accessory_drawing')
		|| (data.products || []).some(p => p && (p.draw_png || p.draw_json))

	const printTotalAmount =
		data.total_amount !== undefined
			? toNumber(data.total_amount)
			: toNumber(profs.totalPrice) +
			toNumber(accessories.totalPrice) +
			toNumber(tunikofons.totalPrice) +
			toNumber(totalAmount.productsTotalPrice)
	const paidAmount = data.net_paid !== undefined ? toNumber(data.net_paid) : toNumber(data.paid)
	const chequeDebt = data.net_cheque_debt !== undefined ? toNumber(data.net_cheque_debt) : toNumber(data.cheque_debt)

	return (
		<div className={`${show ? '' : 'd-none'}`}>
			<div className={`cheque cheque-a5 ${show ? 'p-3' : 'a4'}`} ref={printChequeRef}>
				{/* ═══ A5 (148 × 210 мм) — 2026-08-13, foydalanuvchi qarori ═══
				    Sotuvda mijozga A4 emas, A5 beriladi. `a4` klassi va `data.a4`
				    bayrog'i TARIXIY nom bo'lib qoldi — ular 7 joyda ishlatiladi
				    (Cheque.js, cashbox/Index.js, workshop/cheques/Index.js),
				    o'zgartirilsa chek chop etish butunlay uziladi. Shu sabab
				    nom tegilmadi, faqat o'lcham va joylashuv o'zgardi.

				    ⚠️ Chizma qatorining O'NG TOMONI BO'SH qolardi: raqam kataklari
				    tepaga tenglashgan, chizma esa pastga cho'zilgan edi. Endi
				    chizma O'Z ustunida va raqamlar uning O'RTASIGA tenglanadi. */}
				<style>{`
					@page { size: A5 portrait; margin: 8mm; }
					.cheque-a5 { font-size: 10.5px; line-height: 1.4; }
					.cheque-a5 h5 { font-size: 11px; font-weight: 900; letter-spacing: .5px;
						background: #111722; color: #fff; padding: 2px 8px; margin: 9px 0 0; }
					.cheque-a5 .table { font-size: 10.5px; margin-bottom: 0; }
					.cheque-a5 .table th { padding: 3px 4px; white-space: nowrap; }
					/* Raqamlar chizmaning O'RTASIGA — bo'sh joy shu bilan yo'qoladi */
					.cheque-a5 .table td { padding: 3px 4px; vertical-align: middle; }
					.cheque-a5 .dw-cell { width: 118px; }
					.cheque-a5 .dw-img { display: block; width: 110px; height: 70px;
						object-fit: contain; border: 1px solid #000; margin: 2px 0; }
					/* Nom ostidagi eni/yoyma — mijozga foydali, ilgari umuman yo'q edi */
					.cheque-a5 .dw-sub { color: #000; font-size: 9.5px; line-height: 1.3; }
				`}</style>
				<div className="row mb-2">
					<div className="col-6">
						<div className="d-flex align-items-center">
							<QRCodeSVG value={data.promotion_url} height={90} />

							<div>
								<div className="color-grey">{data.pos_name}</div>
								<div className="color-grey">{data.pos_address}</div>
								<div className="color-grey">{regexPhoneNumber(data.pos_phone)}</div>
							</div>
						</div>
					</div>
					<div className="col-6">
						{/* ⚠️ Logotip yo'q bo'lsa BEGONA rasm emas, korxona NOMI chiqadi.
						    Ilgari zaxira ilovaning o'z logotipi (ASProfil) edi va boshqa
						    korxonalar o'z mijozlariga shu logotip bosilgan chek berardi. */}
						<div className="text-center logo">
							{data.logo ?
								<img src={`https://backend.tameer.uz/uploads/poses/${data.logo}`} alt={data.logo} />
								:
								<div style={{ fontWeight: 800, fontSize: '20px', paddingTop: '10px' }}>
									{data.pos_name || ''}
								</div>
							}
						</div>
					</div>
				</div>

				<div className="row mb-3">
					<div className="col-6">
						{data.id &&
							<h5>{t('order')} № {chequeNumber(data)}</h5>
						}

						{
							<div className="d-between">
								<div>{t('date')}</div>
								<div>{formatDate(data.cheque_opened_at ? data.cheque_opened_at : new Date(), "dd.MM.yyyy HH:mm")}</div>
							</div>
						}
						<div className="d-between">
							<div>{t('client')}</div>
							<div>{data.client_name}</div>
						</div>
						<div className="d-between">
							<div>{t('phone')}</div>
							<div>{regexPhoneNumber(data.client_phone)}</div>
						</div>
						{/* MANZIL: tanlangan hudud nomi (masalan «Chem») + eski erkin matnli manzil (eski cheklarда bor) */}
						{[data.client_region, data.address].filter(Boolean).length > 0 &&
							<div className="d-between">
								<div>{t('address')}</div>
								<div>{[data.client_region, data.address].filter(Boolean).join(', ')}</div>
							</div>
						}
						{data.note &&
							<div className="d-between">
								<div>{t('note')}</div>
								<div>{data.note}</div>
							</div>
						}
					</div>

					<div className="col-6">
						<div className="d-flex flex-column justify-content-end h-100">
							<div className="d-between">
								<div>{t('cashier')}</div>
								<div>{data.cashier_name}</div>
							</div>
							<div className="d-between">
								<div>{t('phone')}</div>
								<div>{regexPhoneNumber(data.cashier_phone)}</div>
							</div>
							{data.delivery_type_id &&
								<div className="d-between">
									<div>{t('delivery_type')}</div>
									<div>{data.delivery_type_name}</div>
								</div>
							}
							{data.courier_login &&
								<div className="d-between">
									<div>{t('courier')}</div>
									<div>{data.courier_name}</div>
								</div>
							}

							{data.delivery_date &&
								<div className="d-between">
									<div>{t('delivery_date')}</div>
									<div>{formatDate(data.delivery_date, "dd.MM.yyyy HH:mm")}</div>
								</div>
							}
						</div>
					</div>
				</div>
				<div>

					{profs?.children?.length > 0 &&
						<>
							<hr />
							<h5>{t('profiled_sheeting')}</h5>

							<table className="table table-border mt-2 mb-0">
								<thead>
									<tr>
										<th style={{ width: '30%' }}>{t('name2')}</th>
										<th style={{ width: '30%' }}>{t('roll')}</th>
										<th style={{ minWidth: '45px' }} className="text-end td-ellipsis">{t('size')}</th>
										<th style={{ minWidth: '40px' }} className="text-end td-ellipsis">{t('quantity2')}</th>
										<th style={{ minWidth: '45px' }} className="text-end td-ellipsis">{t('metr')}</th>
										<th style={{ minWidth: '70px' }} className="text-end td-ellipsis">{t('price')}</th>
										<th style={{ minWidth: '90px' }} className="text-end td-ellipsis">{t('amount')}</th>
									</tr>
								</thead>
								<tbody>
									{profs.children?.map((item, index) => (
										<tr key={index}>
											<td className="py-0 pe-0">
												{item.product_name}
												{/* CHEREPITSA boshi/shag (2026-08-27) — sotuvchi kiritadi,
												    mijoz chekida ham ko'rinadi (adashmaslik uchun) */}
												{((item.tile_start_sm ?? '') !== '' || (item.tile_step_sm ?? '') !== '') &&
													<div style={{ fontSize: '11px', fontWeight: 700 }}>
														{(item.tile_start_sm ?? '') !== '' && <>{t('tile_start')}: {formatMoney(item.tile_start_sm, 1)} {t('sm_unit')}</>}
														{(item.tile_start_sm ?? '') !== '' && (item.tile_step_sm ?? '') !== '' && ' · '}
														{(item.tile_step_sm ?? '') !== '' && <>{t('tile_step')}: {formatMoney(item.tile_step_sm, 1)} {t('sm_unit')}</>}
													</div>}
											</td>
											<td className="pt-0">{item.element_name}</td>
											<td className="pt-0 text-end">{item.element_quantity}</td>
											<td className="py-0 text-end">{item.quantity}</td>
											<td className="py-0 text-end">{formatMoney((item.print_metr), 3)}</td>
											<td className="py-0 text-end">{formatMoney(item.sale_price)}</td>
											<td className="pt-0 text-end">{formatMoney(item.print_total_price)}</td>
										</tr>
									))
									}
									<tr className="tr-bold">
										<td>{t('total')}</td>
										<td></td>
										<td></td>
										<td></td>
										<td className="text-end">{formatMoney(profs.totalQuantity, 3)}</td>
										<td></td>
										<td className="text-end">{formatMoney(profs.totalPrice)}</td>
									</tr>
								</tbody>
							</table>
						</>
					}

					{profs?.preparedChildren?.length > 0 &&
						<>
							<hr />
							<b>{t('prepared_prof')}</b>

							<table className="table table-border mt-2 mb-0">
								<thead>
									<tr>
										<th style={{ width: '30%' }}>{t('name2')}</th>
										<th style={{ width: '30%' }}>{t('roll')}</th>
										<th style={{ minWidth: '55px' }} className="text-end td-ellipsis">{t('quantity')}</th>
										<th style={{ minWidth: '60px' }} className="text-end td-ellipsis">{t('price')}</th>
										<th style={{ minWidth: '100px' }} className="text-end td-ellipsis">{t('total_amount')}</th>
									</tr>
								</thead>
								<tbody>
									{profs.preparedChildren?.map((item, index) => (
										<tr key={index}>
											<td className="pt-0">{item.product_name}</td>
											<td className="pt-0">{item.element_name}</td>
											<td className="py-0 text-end">{formatMoney(item.print_quantity, 3)}</td>
											<td className="py-0 text-end">{formatMoney(item.sale_price)}</td>
											<td className="pt-0 text-end">{formatMoney(item.print_total_price)}</td>
										</tr>
									))
									}
									<tr className="tr-bold">
										<td>{t('total')}</td>
										<td></td>
										<td className="text-end">{formatMoney(profs.totalQuantity, 3)}</td>
										<td></td>
										<td className="text-end">{formatMoney(profs.totalPrice)}</td>
									</tr>
								</tbody>
							</table>
						</>
					}
				</div>

				<div>
					{accessories?.children?.length > 0 &&
						<>
							<hr />
							<h5>{t('accessory')}</h5>

							<table className="table table-border mt-2">
								<thead>
									<tr>
										<th style={{ width: '26%' }}>{t('name2')}</th>
										{showDraw && <th className="dw-cell">{t('drawing')}</th>}
										<th style={{ width: '19%' }}>{t('roll')}</th>
										<th style={{ minWidth: '45px' }} className="text-end td-ellipsis">{t('size')}</th>
										<th style={{ minWidth: '40px' }} className="text-end td-ellipsis">{t('quantity2')}</th>
										<th style={{ minWidth: '45px' }} className="text-end td-ellipsis">{t('metr')}</th>
										<th style={{ minWidth: '70px' }} className="text-end td-ellipsis">{t('price')}</th>
										<th style={{ minWidth: '90px' }} className="text-end td-ellipsis">{t('amount')}</th>
									</tr>
								</thead>
								<tbody>
									{accessories.children?.map((item, index) => (
										<tr key={index}>
											<td>
												{item.product_name}
												{drawSub(item)}
											</td>
											{/* CHIZMA — o'z ustunida. Nom katagi ichida bo'lganda
											    qator cho'zilib, o'ng tomon bo'sh qolardi. */}
											{showDraw &&<td className="dw-cell">
												{drawingForCheque(item, 'client') &&
													<img src={drawingForCheque(item, 'client')} alt="" className="dw-img" />}
											</td>}
											<td>{item.element_name}</td>
											<td className="text-end">{item.element_quantity}</td>
											<td className="text-end">{item.quantity}</td>
											<td className="text-end">{formatMoney((item.print_metr), 3)}</td>
											<td className="text-end">{formatMoney(item.sale_price)}</td>
											<td className="text-end">{formatMoney(item.print_total_price)}</td>
										</tr>
									))
									}
									{/* colSpan ustunlar soniga mos: nom · chizma · rulon ·
										    o'lcham · soni = 5, keyin metr · narx · summa */}
										<tr className="tr-bold">
											<td colSpan={showDraw ? 5 : 4}>{t('total')}</td>
											<td className="text-end">{formatMoney(accessories.totalQuantity, 3)}</td>
											<td></td>
											<td className="text-end">{formatMoney(accessories.totalPrice)}</td>
										</tr>
								</tbody>
							</table>
						</>
					}

					{accessories?.preparedChildren?.length > 0 &&
						<>
							<hr />
							<h5>{t('prepared_accessory')}</h5>

							<table className="table table-border mt-2 mb-0">
								<thead>
									<tr>
										<th style={{ width: '30%' }}>{t('name2')}</th>
										<th style={{ width: '30%' }}>{t('roll')}</th>
										<th style={{ minWidth: '55px' }} className="text-end td-ellipsis">{t('quantity')}</th>
										<th style={{ minWidth: '60px' }} className="text-end td-ellipsis">{t('price')}</th>
										<th style={{ minWidth: '100px' }} className="text-end td-ellipsis">{t('total_amount')}</th>
									</tr>
								</thead>
								<tbody>
									{accessories.preparedChildren?.map((item, index) => (
										<tr key={index}>
											<td className="pt-0">{item.product_name}</td>
											<td className="pt-0">{item.element_name}</td>
											<td className="py-0 text-end">{formatMoney(item.print_quantity, 3)}</td>
											<td className="py-0 text-end">{formatMoney(item.sale_price)}</td>
											<td className="pt-0 text-end">{formatMoney(item.print_total_price)}</td>
										</tr>
									))
									}
									{/* TAYYOR aksessuar — 5 ustunli jadval, chizma ustuni YO'Q
									    (tayyor mahsulot omborda turadi, chizma bo'yicha
									    yasalmaydi). Shu sabab bu qator 5 katakligicha qoladi. */}
									<tr className="tr-bold">
										<td>{t('total')}</td>
										<td></td>
										<td className="text-end">{formatMoney(accessories.totalQuantity, 3)}</td>
										<td></td>
										<td className="text-end">{formatMoney(accessories.totalPrice)}</td>
									</tr>
								</tbody>
							</table>
						</>
					}
				</div>

				<div>
					{tunikofons?.children?.length > 0 &&
						<>
							<hr />
							<h5>{t('tunikofon')}</h5>

							<table className="table table-border mt-2">
								<thead>
									<tr>
										<th style={{ width: '26%' }}>{t('name2')}</th>
										{showDraw && <th className="dw-cell">{t('drawing')}</th>}
										<th style={{ width: '19%' }}>{t('roll')}</th>
										<th style={{ minWidth: '45px' }} className="text-end td-ellipsis">{t('size')}</th>
										<th style={{ minWidth: '40px' }} className="text-end td-ellipsis">{t('quantity2')}</th>
										<th style={{ minWidth: '45px' }} className="text-end td-ellipsis">{t('sq_m')}</th>
										<th style={{ minWidth: '70px' }} className="text-end td-ellipsis">{t('price')}</th>
										<th style={{ minWidth: '90px' }} className="text-end td-ellipsis">{t('amount')}</th>
									</tr>
								</thead>
								<tbody>
									{tunikofons.children?.map((item, index) => (
										<tr key={index}>
											<td>
												{item.product_name}
												{drawSub(item)}
											</td>
											{/* TUNUKAFON CHIZMASI — 2026-08-13 da qo'shildi.
											    Ilgari chizma faqat aksessuarda bor edi, mijoz
											    karniz bilan doskani nomiga qarab ajratardi. */}
											{showDraw &&<td className="dw-cell">
												{drawingForCheque(item, 'client') &&
													<img src={drawingForCheque(item, 'client')} alt="" className="dw-img" />}
											</td>}
											<td className="td-ellipsis">{item.element_name}</td>
											<td className="text-end">{item.element_quantity}</td>
											<td className="text-end">{item.quantity}</td>
											<td className="text-end">{formatMoney((item.print_sq_m), 3)}</td>
											<td className="text-end">{formatMoney(item.sale_price)}</td>
											<td className="text-end">{formatMoney(item.print_total_price)}</td>
										</tr>
									))
									}
									<tr className="tr-bold">
										<td colSpan={showDraw ? 5 : 4}>{t('total')}</td>
										<td className="text-end">{formatMoney(tunikofons.totalQuantity, 3)}</td>
										<td></td>
										<td className="text-end">{formatMoney(tunikofons.totalPrice)}</td>
									</tr>
								</tbody>
							</table>
						</>
					}

					{tunikofons?.preparedChildren?.length > 0 &&
						<>
							<hr />
							<h5>{t('prepared_tunicophone')}</h5>

							<table className="table table-border mt-2 mb-0">
								<thead>
									<tr>
										<th style={{ width: '30%' }}>{t('name2')}</th>
										<th style={{ width: '30%' }}>{t('roll')}</th>
										<th style={{ minWidth: '55px' }} className="text-end td-ellipsis">{t('quantity')}</th>
										<th style={{ minWidth: '60px' }} className="text-end td-ellipsis">{t('price')}</th>
										<th style={{ minWidth: '100px' }} className="text-end td-ellipsis">{t('total_amount')}</th>
									</tr>
								</thead>
								<tbody>
									{tunikofons.preparedChildren?.map((item, index) => (
										<tr key={index}>
											<td className="pt-0">{item.product_name}</td>
											<td className="pt-0">{item.element_name}</td>
											<td className="py-0 text-end">{formatMoney(item.print_quantity, 3)}</td>
											<td className="py-0 text-end">{formatMoney(item.sale_price)}</td>
											<td className="pt-0 text-end">{formatMoney(item.print_total_price)}</td>
										</tr>
									))
									}
									<tr className="tr-bold">
										<td>{t('total')}</td>
										<td></td>
										<td className="text-end">{formatMoney(tunikofons.totalQuantity, 3)}</td>
										<td></td>
										<td className="text-end">{formatMoney(tunikofons.totalPrice)}</td>
									</tr>
								</tbody>

							</table>
						</>
					}
				</div>

				{products.length > 0 &&
					<div>
						<hr />
						<h5>{t('products')}</h5>

						<table className="table table-border mt-2">
							<thead>
								<tr>
									<th style={{ width: '40%' }}>{t('name2')}</th>
									<th style={{ width: '15%' }} className="text-end">{t('quantity')}</th>
									<th style={{ width: '15%' }} className="text-end">{t('price')}</th>
									<th style={{ width: '20%' }} className="text-end">{t('total_amount')}</th>
								</tr>
							</thead>
							<tbody>
								{products?.map((item, index) => (
									<tr key={index}>
										<td>{item.product_name}</td>
										<td className="text-end">{formatMoney(item.print_quantity, 3)}</td>
										<td className="text-end">{formatMoney(item.sale_price)}</td>
										<td className="text-end">{formatMoney(item.print_total_price)}</td>
									</tr>
								))
								}
								<tr className="tr-bold">
									<td>{t('total')}</td>
									<td className="text-end">{formatMoney(totalAmount.productsTotalQuantity, 3)}</td>
									<td></td>
									<td className="text-end">{formatMoney(totalAmount.productsTotalPrice)}</td>
								</tr>
							</tbody>
						</table>
					</div>
				}

				<hr />
				<div className="d-flex flex-column align-items-end">
					<div className="d-between gap-2 fz-18">
						<div>{t('to_pay')}:</div>
						<div className="text-end" style={{ width: '140px' }}>
							{formatMoney(printTotalAmount)}
						</div>
					</div>
					{/* Faqat HAQIQIY pul: Накд / Банк / P2P.
					    Насия (3-kategoriya) bu yerda ko'rsatilmaydi — u to'lov emas, QARZ.
					    U pastdagi "Буюртма қарзи" satrida chiqadi. Ilgari ikkalasi ham ko'rinib,
					    bitta chekda ikki xil raqam turardi (Насия 4 700 000 va qarz 3 900 000) — chalkash edi. */}
					{Object.values(
						(data?.payments || [])
							.filter(p => Number(p.amount) > 0 && Number(p.payment_type_category_id) !== 3)
							// Bir xil tur bir necha marta to'langan bo'lsa (Накд 400 000 + Накд 100 000)
							// bitta qatorga yig'iladi: "Накд: 500 000"
							.reduce((acc, p) => {
								const key = p.payment_type_id
								if (!acc[key]) acc[key] = { name: p.name, amount: 0 }
								acc[key].amount += Number(p.amount)
								return acc
							}, {})
					).map((item, index) => (
						<div className="d-between gap-2" key={index}>
							<div>{item.name}:</div>
							<div className="text-end" style={{ width: '140px' }}>
								{formatMoney(item.amount)}
							</div>
						</div>
					))}
					{toNumber(data.total_returned_amount) > 0 &&
						<div className="d-between gap-2">
							<div>
								{t('return')}
								{(totalAmount.returnedMetr > 0 || totalAmount.returnedSqM > 0 || totalAmount.returnedCount > 0) &&
									<span> ({[
										totalAmount.returnedMetr > 0 ? `${formatMoney(totalAmount.returnedMetr, 3)} m` : null,
										totalAmount.returnedSqM > 0 ? `${formatMoney(totalAmount.returnedSqM, 3)} ${t('sq_m')}` : null,
										totalAmount.returnedCount > 0 ? `${formatMoney(totalAmount.returnedCount, 3)} ${t('piece')}` : null,
									].filter(Boolean).join(' + ')})</span>}
								:
							</div>
							<div className="text-end text-danger" style={{ width: '140px' }}>
								- {formatMoney(data.total_returned_amount)}
							</div>
						</div>
					}

					{/* {data.paid > 0 &&
						<div className="d-between fw-600">
							<div>{t('paid')}</div>
							<div>{data.paid ? formatMoney(data.paid) : 0}</div>
						</div>
					}
					{data.change > 0 &&
						<div className="d-between fw-600">
							<div>{t('change')}</div>
							<div>{formatMoney(data.change)}</div>
						</div>
					}
					{data?.payments?.map((item, index) => (
						item.amount > 0 &&
						<div className="d-between" key={index}>
							<div>{item.name}</div>
							<div>{formatMoney(item.amount)}</div>
						</div>
					))}
					<div className="d-between">
						<div>{t('amount_of_debt')}</div>
						<div>{formatMoney(data.client_balance)}</div>
					</div> */}
				</div>

				<div className="devider">
					<div className="d-between gap-2">
						<div>{t('paid')}:</div>
						<div className="text-end" style={{ width: '140px' }}>
							{formatMoney(paidAmount)}
						</div>
					</div>

					<div>
						{/* <div className="d-between gap-2">
							<div>{t('to_pay')}:</div>
							<div className="text-end" style={{ width: '140px' }}>
								{data.total_amount ? formatMoney(data.total_amount) : 0}
							</div>
						</div> */}
						<div className="d-between gap-2">
							<div>{t('order_debt')}</div>
							<div className="text-end" style={{ width: '140px' }}>
								{formatMoney(chequeDebt)}
							</div>
						</div>
					</div>
				</div>

				<div className="d-between">
					<div className="w-50" style={{ whiteSpace: 'pre-line' }}>
						{getChequeNote(reduxAccount.role)}
					</div>

					<div>
						{/* <div className="d-between w-100">
							<div>{t('order_debt')}</div>
							<div className="text-end" style={{ width: '130px' }}>
								{formatMoney(data.cheque_debt)}
							</div>
						</div> */}
						<div className="d-between w-100">
							<div>{t('previous_debt')}</div>
							<div className="text-end" style={{ width: '130px' }}>
								{/* Qarz mijoz balansiga chek YARATILGANDA yoziladi (statusга bog'liq EMAS),
								    shu sabab client_balance shu chekni ALLAQACHON o'z ichiga oladi.
								    Аввалги қарз = joriy balans − shu chek qarzi (aks holda ikkilanadi).
								    NET chek qarzi (chequeDebt) ishlatilsin: qaytarishda GROSS (data.cheque_debt)
								    ishlatilsa, qaytarish summasi soxta "avvalgi qarz" bo'lib chiqardi. */}
								{formatMoney(Math.abs(Number(data.client_balance) + chequeDebt))}
							</div>
						</div>
						<div className="d-between w-100">
							<div>{t('total_debt')}</div>
							<div className="text-end" style={{ width: '130px' }}>
								{/* Жами қарз = mijozning JORIY umumiy qarzi (client_balance) — shu chek allaqachon ichida. */}
								{formatMoney(Math.abs(Number(data.client_balance)))}

							</div>
						</div>
					</div>
				</div>

				<div className="d-flex fw-500 mt-4">
					<div className="d-between align-items-end gap-2 w-100">

						<div className="w-100 no-wrap">
							{reduxAccount.role === 'ROLE_WORKSHOP' ?
								t('received_the_order')
								:
								t('formalized_order')
							}:
						</div>

						<div className="signature" />
					</div>

					<div className="d-between align-items-end gap-2 w-50">
						<div className="w-100 no-wrap">{t('signature')}:</div>

						<div className="signature" />
					</div>
				</div>
			</div>
		</div>
	)
}

export default ChequeA4